module.exports = __webpack_public_path__ + "img/15.1f90a4c1.jpg";